import { rest, RestHandler } from 'msw';
import { PATHS, STATUS } from 'adapters/constants';
import {
  vendorsTableData,
  vendorsTableDataByDueDate,
  vendorsTableDataByPaymentMethod,
  vendorsTableDataByDueDateAndByPaymentMethod
} from 'mocks/mockData/vendorsTableData';

export const vendorsTableHandler: RestHandler[] = [
  rest.get(PATHS.getVendorsPath('1'), (_, res, ctx) => {
    const paymentMethod = _.url.searchParams.get('paymentMethod');
    const dueDate = _.url.searchParams.get('dueDate');
    if (dueDate && paymentMethod) {
      return res(
        ctx.status(STATUS.SUCCESS),
        ctx.json(vendorsTableDataByDueDateAndByPaymentMethod(paymentMethod))
      );
    }
    if (dueDate) {
      return res(
        ctx.status(STATUS.SUCCESS),
        ctx.json(vendorsTableDataByDueDate)
      );
    }
    if (paymentMethod) {
      return res(
        ctx.status(STATUS.SUCCESS),
        ctx.json(vendorsTableDataByPaymentMethod(paymentMethod))
      );
    }
    return res(ctx.status(STATUS.SUCCESS), ctx.json(vendorsTableData));
  })
];
